import {
  SET_AUTH_PROGRESS,
  SET_USER,
  START_LOADING,
  SET_AD_GROUPS,
  STOP_LOADING,
  SET_USERS_LOADING,
  SET_USERS,
  SET_CURRENT_USER_ADP_PERMISSION,
  UPDATE_CURRENT_USER_ADP_PERMISSION_DATA_LOADED_STATE,
  SET_USERS_PERMISSIONS,
} from './mutation-types';
import {axiosClient, msgClient} from '../../../core/services/http.service';

export async function setAuthProgress({commit}, progress) {
  commit(SET_AUTH_PROGRESS, progress);
}

export async function setCurrentUser({commit}, user) {
  commit(SET_USER, user);
}

export async function getUserAdGroups({commit}) {
  commit(START_LOADING, 'adGroups');
  try {
    const adGroups = await msgClient.api('/me/memberOf').get();
    commit(STOP_LOADING, 'adGroups');
    commit(SET_AD_GROUPS, adGroups.value);
  } catch (e) {
    commit(STOP_LOADING, 'adGroups');
  }
}

export async function getUsersAndGroups({commit}, searchTerm = '') {
  commit(SET_USERS_LOADING, true);
  const {success, body} = await axiosClient.get(`api/aad/users-and-groups?searchTerm=${searchTerm}`);
  commit(SET_USERS_LOADING, false);
  if (success) {
    commit(SET_USERS, body);
  }
  return body;
}

export async function getUsersAndGroupsForIds({commit}, data) {
  return await axiosClient.post('api/aad/users', data);;
}

export async function getUsersAndGroupsWithPermissions({commit}, searchTerm = '') {
  commit(SET_USERS_LOADING, true);
  const {success, body} = await axiosClient.get(`api/aad/users-and-groups?searchTerm=${searchTerm}`);
  if (success) {
    const users = body;
    const {success, body: permissions} = await axiosClient.get('/api/ADPPermission');
    if (success) {
      const usersMap = new Map(permissions.map(p => [p.userGuid, p]));
      users.forEach(user => {
        user.permission = usersMap.get(user.id) || {role: null, userGuid: user.id};
      });
    }
    commit(SET_USERS_LOADING, false);
    commit(SET_USERS, users);
  }
  return body;
}

export async function getCurrentUserAdpPermission({commit}) {
  const {success, body} = await axiosClient.get('api/adppermission/currentuser');
  if (success) commit(SET_CURRENT_USER_ADP_PERMISSION, body);
  commit(UPDATE_CURRENT_USER_ADP_PERMISSION_DATA_LOADED_STATE);
}

export const getUsersPermissions = async ({commit}) => {
  const {success, body} = await axiosClient.get('/api/ADPPermission');
  if (success) {
    commit(SET_USERS_PERMISSIONS, body);
  }
};